import { euro } from '../../core/format/currency';
export type PurchaseOption = {
  value: boolean;
  title: string;
  meta: string;
};
type Props = {
  /** Uniek per keuze op de pagina (radio-groep). */
  name: string;
  price: number;
  /** Eenmalig eerst, bijvullen erna. Nooit vooraf aangevinkt: de aanroeper begint op `false`. */
  options: readonly PurchaseOption[];
  value: boolean;
  onChange: (subscribe: boolean) => void;
  legend?: string;
};

/**
 * Eenmalig of bijvullen, als twee keuzerondjes met de prijs erbij. Bijvullen kost hetzelfde:
 * "zelfde prijs", het voordeel zit in verzending en cadeau, nooit in korting. Eén vorm voor de
 * productpagina en het complete protocol.
 */
export function PurchaseOptions({
  name,
  price,
  options,
  value,
  onChange,
  legend = 'Aankoopoptie'
}: Props) {
  return <fieldset className="space-y-2" data-id="element-9002" data-mp="230fu7naugikx">
      <legend className="sr-only" data-id="element-9003" data-mp="22ze8mow7cdoy">{legend}</legend>
      {options.map(o => {
      const active = value === o.value;
      return <label key={o.title} className={`flex cursor-pointer items-start gap-4 border p-4 transition-colors duration-150 ease-soft [&:has(:focus-visible)]:outline [&:has(:focus-visible)]:outline-2 [&:has(:focus-visible)]:outline-offset-2 [&:has(:focus-visible)]:outline-clay ${active ? 'border-ink bg-shell' : 'border-line hover:border-ink/40'}`} data-id="element-9004" data-mp="2743zu0fx143j">
            <input type="radio" name={name} checked={active} onChange={() => onChange(o.value)} className="sr-only" data-id="element-9005" data-mp="5ub0917fnxuo" />
            <span aria-hidden="true" className={`mt-1 flex h-4 w-4 shrink-0 items-center justify-center rounded-full border ${active ? 'border-ink' : 'border-line'}`} data-id="element-9006" data-mp="132se9lr4kjm">
              {active && <span className="h-2 w-2 rounded-full bg-ink" data-id="element-9007" data-mp="3nasyakqd9rtd" />}
            </span>
            <span className="flex-1" data-id="element-9008" data-mp="3n8pyxa3bqmbz">
              <span className="flex items-baseline justify-between gap-3" data-id="element-9009" data-mp="3j9pfpqgxphog">
                <span className="text-[15px] text-ink" data-id="element-9010" data-mp="3ea4hji9l9dcs">{o.title}</span>
                <span className="shrink-0 text-right" data-id="element-9011" data-mp="3eawdiu73ld3l">
                  <span className="type-name text-ink" data-id="element-9012" data-mp="34m8zfjxqvbbu">{euro(price)}</span>
                  {o.value && <span className="block text-[12px] text-clay" data-id="element-9013" data-mp="38nu5albv2pcj">zelfde prijs</span>}
                </span>
              </span>
              <span className="mt-1 block text-[13px] leading-relaxed text-muted" data-id="element-9014" data-mp="2upcnt5cju932">{o.meta}</span>
            </span>
          </label>;
    })}
    </fieldset>;
}